import { render } from "./Monaco.vue?vue&type=template&id=4d0f027a&scoped=true"
import script from "./Monaco.vue?vue&type=script&lang=js"
export * from "./Monaco.vue?vue&type=script&lang=js"

import "./Monaco.vue?vue&type=style&index=0&id=4d0f027a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0f027a"]])

export default __exports__